import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SalesRelease_Create, SalesRelease_Delete, SalesRelease_ReadAll, SalesRelease_ReadByTenantId, SalesRelease_ReadById, SalesRelease_SearchByReleaseNo, SalesRelease_Update } from "src/app/GlobalVariables";
import { SalesReleaseCreateRequestDTO, SalesReleaseDeleteRequestDTO, SalesReleaseDTO, SalesReleaseList, SalesReleaseReadByTenantIdRequestDTO, SalesReleaseReadByIdRequestDTO, SalesReleaseUpdateRequestDTO } from "./sales-release.interface";
import { SalesReleaseSearchByReleaseNoRequestDTO } from "./sales-release-detail/sales-release-detail.interface";

@Injectable({
    providedIn: 'root'
})

export class SalesReleaseService {

    constructor() { }

    http = inject(HttpClient);

    SalesRelease_Create(data: SalesReleaseCreateRequestDTO): Observable<SalesReleaseDTO> {
        return this.http.post<SalesReleaseDTO>(SalesRelease_Create, data);
    }

    SalesRelease_Update(data: SalesReleaseUpdateRequestDTO): Observable<SalesReleaseDTO> {
        return this.http.post<SalesReleaseDTO>(SalesRelease_Update, data);
    }

    SalesRelease_Delete(data: SalesReleaseDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(SalesRelease_Delete, data);
    }

    SalesRelease_ReadAll(): Observable<SalesReleaseList> {
        return this.http.get<SalesReleaseList>(SalesRelease_ReadAll);
    }

    SalesRelease_ReadById(data: SalesReleaseReadByIdRequestDTO): Observable<SalesReleaseDTO> {
        return this.http.post<SalesReleaseDTO>(SalesRelease_ReadById, data);
    }

    SalesRelease_ReadByTenantId(data: SalesReleaseReadByTenantIdRequestDTO): Observable<SalesReleaseList> {
        return this.http.post<SalesReleaseList>(SalesRelease_ReadByTenantId, data);
    }

    SalesRelease_SearchByReleaseNo(data: SalesReleaseSearchByReleaseNoRequestDTO): Observable<SalesReleaseList> {
        return this.http.post<SalesReleaseList>(SalesRelease_SearchByReleaseNo, data)
    }
}